//**auto-generated don't edit this code**//
import {ContractHttpClient, getClientConfig} from '@esgi/contracts';
import {Disposable} from '@esgi/core/service';
import {init} from './endpoints/init';
import {tests} from './endpoints/tests';
import {getReport} from './endpoints/get-report';
import {closeReport} from './endpoints/close-report';
import {markingPeriodAll} from './endpoints/marking-period-all';
import {carryScoresForward} from './endpoints/carry-scores-forward';
import {idChanged} from './endpoints/id-changed';
import {gradeLevel} from './endpoints/grade-level';
import {subjectChanged} from './endpoints/subject-changed';
import {downloadExcel} from './endpoints/download-excel';
import {downloadPdf} from './endpoints/download-pdf';

export class V2TeachersPagesReportsTotalsController implements Disposable {
	private httpClientConfig = getClientConfig('esgi-apigateway');
	private httpClient: ContractHttpClient = new ContractHttpClient(this.httpClientConfig);

	public init = init(this.httpClient);
	public tests = tests(this.httpClient);
	public getReport = getReport(this.httpClient);
	public closeReport = closeReport(this.httpClient);
	public markingPeriodAll = markingPeriodAll(this.httpClient);
	public carryScoresForward = carryScoresForward(this.httpClient);
	public idChanged = idChanged(this.httpClient);
	public gradeLevel = gradeLevel(this.httpClient);
	public subjectChanged = subjectChanged(this.httpClient);
	public downloadExcel = downloadExcel(this.httpClient);
	public downloadPdf = downloadPdf(this.httpClient);

	public dispose(): void {
		this.httpClient?.destroy();
	}
}
